// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateOrganizationMembershipMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  inviteEmail: Types.Scalars["String"]["input"];
  roleIds: Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"];
}>;

export type CreateOrganizationMembershipMutation = {
  __typename?: "Mutation";
  createOrganizationMembership: {
    __typename?: "OrganizationMembership";
    id: string;
    email: string;
  };
};

export const CreateOrganizationMembershipDocument = gql`
  mutation CreateOrganizationMembership(
    $organizationSlug: ID!
    $inviteEmail: String!
    $roleIds: [ID!]!
  ) {
    createOrganizationMembership(
      organizationSlug: $organizationSlug
      inviteEmail: $inviteEmail
      roleIds: $roleIds
    ) {
      id
      email
    }
  }
`;
export type CreateOrganizationMembershipMutationFn = Apollo.MutationFunction<
  CreateOrganizationMembershipMutation,
  CreateOrganizationMembershipMutationVariables
>;

/**
 * __useCreateOrganizationMembershipMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMembershipMutation, { data, loading, error }] = useCreateOrganizationMembershipMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      inviteEmail: // value for 'inviteEmail'
 *      roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useCreateOrganizationMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrganizationMembershipMutation,
    CreateOrganizationMembershipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOrganizationMembershipMutation,
    CreateOrganizationMembershipMutationVariables
  >(CreateOrganizationMembershipDocument, options);
}
export type CreateOrganizationMembershipMutationHookResult = ReturnType<
  typeof useCreateOrganizationMembershipMutation
>;
export type CreateOrganizationMembershipMutationResult =
  Apollo.MutationResult<CreateOrganizationMembershipMutation>;
export type CreateOrganizationMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    CreateOrganizationMembershipMutation,
    CreateOrganizationMembershipMutationVariables
  >;
